import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/setting/kpi-list/`;

const getKpiLists = async () => {
    return await axios.get(API_URL);
};

/** Get KPI list for view (allowed for superuser + admin, read-only) */
const getKpiListsView = async () => {
    return await axios.get(API_URL + 'view');
};

const getKpiList = async (id) => {
    return await axios.get(API_URL + id);
};

const addKpiList = async (kpiListData) => {
    return await axios.post(API_URL, kpiListData);
};

const editKpiList = async (kpiListId, updatedData) => {
    return await axios.put(API_URL + kpiListId, updatedData);
};

const deleteKpiList = async (kpiListId) => {
    return await axios.delete(API_URL + kpiListId);
};

export default {
    getKpiLists,
    getKpiListsView,
    getKpiList,
    addKpiList,
    editKpiList,
    deleteKpiList
};

